import React from 'react';
import { Box, Button, Chip, Stack, Typography } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CopyLinkRow from './CopyLinkRow';
import { formatLinkPriceSummary, type TicketLinkDisplayInfo } from './paymentFormUtils';
import { useBrandRegistrationCopy } from '../../../brands/registrationCopy';

interface SavedLinkCardProps {
  label: string;
  url: string;
  refCode?: string;
  info: TicketLinkDisplayInfo;
  onEdit?: () => void;
  onDelete?: () => void;
}

const SavedLinkCard: React.FC<SavedLinkCardProps> = ({ label, url, refCode, info, onEdit, onDelete }) => {
  const t = useBrandRegistrationCopy();
  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
      }}
    >
      <Stack spacing={1.5}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, flexWrap: 'wrap' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
            <Typography variant="subtitle2" fontWeight={700}>
              {label}
            </Typography>
            {info.hasDiscount ? (
              <Chip size="small" color="success" label="Com desconto" />
            ) : (
              <Chip size="small" variant="outlined" label="Preço normal" />
            )}
            {info.priceIsFixed ? (
              <Chip size="small" variant="outlined" label="Valor fixo" />
            ) : (
              <Chip size="small" variant="outlined" label="Segue o ingresso" />
            )}
          </Box>
          {(onEdit || onDelete) && (
            <Stack direction="row" spacing={0.5} flexShrink={0}>
              {onEdit && (
                <Button size="small" startIcon={<EditOutlinedIcon />} onClick={onEdit}>
                  Editar
                </Button>
              )}
              {onDelete && (
                <Button size="small" color="error" startIcon={<DeleteOutlineIcon />} onClick={onDelete}>
                  Excluir
                </Button>
              )}
            </Stack>
          )}
        </Box>

        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 1 }}>
          <Typography variant="body2" color="text.secondary">
            <strong>Ingresso:</strong> {t(info.ticketName)}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            <strong>Valor cobrado:</strong> {formatLinkPriceSummary(info)}
          </Typography>
          {refCode && (
            <Typography variant="body2" color="text.secondary">
              <strong>Código ref:</strong> {refCode}
            </Typography>
          )}
        </Box>

        <Typography variant="caption" color="text.secondary" display="block">
          {t(info.priceBehavior)}
        </Typography>

        <CopyLinkRow label="Link para compartilhar" link={url} compact />
      </Stack>
    </Box>
  );
};

export default SavedLinkCard;
